import React, { useEffect } from "react";

import Header from "parts/Header";
import { useParams } from "react-router-dom";
import PortfolioDetail from "parts/PortfolioDetail";
import Footer from "parts/Footer";

import { useProducts } from "lib/useProducts";

export const ProjectDetailPage = () => {
  const { id } = useParams();
  const { products, isLoading } = useProducts();
  const product = products.find((item) => String(item.id) === id) || null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <PortfolioDetail product={product} isLoading={isLoading} />
      <Footer />
    </>
  );
};
